*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  --window-max-height: none;
  --window-gap: 50px;
}

.main-wrapper {
  display: block;
}

/*label*/
.label-input-wrapper {
  display: flex;
}
.label-input-wrapper .input {
  flex: 1;
}

:host([label-position=start]) .label-input-wrapper {
  flex-direction: row;
}

:host([label-position=above]) .label-input-wrapper {
  flex-direction: column;
}

/*input*/
.input {
  background-color: unset;
  border: none;
  color: inherit;
  font: inherit;
  margin: 0;
  padding: 0;
  outline: 0;
}

/*window*/
.ch-window-container {
  position: relative;
}

ch-window::part(window) {
  width: 100%;
  max-height: calc(var(--window-max-height) - var(--window-gap));
  overflow-y: auto;
}